import React, { useEffect, useState } from 'react';
import { IonSplitPane, IonMenu, IonHeader, IonToolbar, IonTitle, IonContent, IonList, IonItem, IonRouterOutlet, IonIcon, IonLabel, useIonToast, useIonAlert } from '@ionic/react';
import { Route, RouteComponentProps, withRouter } from 'react-router-dom';
import { person, archive, briefcase, open, home, statsChart, chevronDown, chevronForward } from 'ionicons/icons';
import { useLocation } from "react-router-dom";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { RootState } from '../../redux/reducers';

import './AppMenu.css';
import {
    StatisticsOverview,
    StatisticsDetail,
    Profile,
    Newsfeed,
    NewsfeedDetail,
    StatisticsDetailCompressed,
    ForbiddenPage,
    StatisticCategories,
    JobsOverview,
    MediaArchive,
    MediaArchiveDetail, /* SurveyPage, */
    ActivityPage,
    ExcellentCompaniesPage,
    RegisterExcellentCompanyPage,
    StatisticMaintenance
} from '../../pages';
import { getFcmMessageToken, getUser } from '../../redux/user/user.actions';
import NotFoundPage from '../../pages/errorPages/404';
import { onMessageListener } from '../../firebase';
import packageJson from '../../../package.json';
import http from '../../utils/http-common';


const AppMenu: React.FC<RouteComponentProps> = ({ match }) => {
    let path = useLocation().pathname;
    const user = useSelector((state: RootState) => state.user.user, shallowEqual)
    const dispatch = useDispatch();
    const temporaryLoggedIn = useSelector((state: RootState) => state.user.temporaryLogin);
    const messageToken = useSelector((state: RootState) => state.user.fcm_token)
    const [present, dismiss] = useIonToast();
    const [isAusbildungOpen, setIsAusbildungOpen] = useState(false);
    const [presentAlert] = useIonAlert();

    useEffect(() => {
        if (messageToken.token === "") {
            dispatch(getFcmMessageToken())
        }
    }, [messageToken, dispatch])


    /* Push Notification Listener wenn App im Vordergrund ist */
    onMessageListener().then(payload => {
        //console.log("in appmenu", payload)
        present({
            buttons: [{
                icon: open, handler: () => {
                    dismiss()
                    window.location.href = payload.data.link
                }
            }],
            message: '<b>' + payload.data.title + '</b><br/>' + payload.data.body + '',
            duration: 5000,
            color: 'light'
        })
    }).catch(err => console.log('failed: ', err));

    useEffect(() => {
        dispatch(getUser());
    }, [dispatch])

    useEffect(() => {
        // Check if we already showed the alert for this version
        const lastShownVersion = localStorage.getItem('lastShownVersion');
        const lastCheckTimestamp = localStorage.getItem('lastVersionCheckTimestamp');
        const currentTime = new Date().getTime();
        const oneHourInMs = 3600000;
        
        // Only check if 1 hour have passed since last check
        if (!lastCheckTimestamp || (currentTime - parseInt(lastCheckTimestamp)) > oneHourInMs) {
            // Fetch version from API
            http.get('/version')
                .then(response => {
                    if (response.data.version !== packageJson.version && response.data.requiresUpdate) {
                        // localStorage.removeItem('lastShownVersion');
                        // localStorage.removeItem('lastVersionCheckTimestamp');
                        if (lastShownVersion !== response.data.version) {
                            presentAlert({
                                header: 'Neue Version verfügbar',
                                message: 'Damit der Mitgliederbereich korrekt angezeigt wird empfehlen wir ihnen den Browser neuzustarten',
                                buttons: ['OK'],
                            });
                            // Save the version and timestamp for which we showed the alert
                        }
                        
                    }
                    localStorage.setItem('lastShownVersion', response.data.version);
                    localStorage.setItem('lastVersionCheckTimestamp', currentTime.toString());
                })
                .catch(error => {
                    console.error('Error fetching version:', error);
                });
        }
    }, []);

    const pages = [
        {
            label: "Newsfeed",
            link: "newsfeed",
            icon: home,
            component: Newsfeed
        },
        {
            label: "Statistik",
            link: "statistik",
            icon: statsChart,
            component: StatisticsOverview
        },
        // {
        //     label: "Statistik",
        //     link: "statistik-wartung",
        //     icon: statsChart,
        //     component: StatisticMaintenance
        // },
        {
            label: "Medien-Archiv",
            link: "medien-archiv",
            icon: archive,
            component: MediaArchive
        },
        {
            label: "Ausbildung",
            icon: briefcase,
            subItems: [
                {
                    label: "Stellenanzeigen",
                    link: "jobs",
                    component: JobsOverview
                },
                {
                    label: "Exzellente Ausbildungsbetriebe",
                    link: "excellent-companies",
                    component: ExcellentCompaniesPage
                }
            ]
        },
    ]

    return (
        <IonSplitPane contentId="main" className="splitPane">
            <IonMenu side="start" contentId="main">
                <IonHeader className="no-shadow">
                    <IonToolbar className='menuToolbar'>
                        <IonTitle>
                            <img src="/assets/images/DESH-Logo.svg" height="36px" width="auto" style={{ marginTop: 7 }} alt="DeSH Logo" />
                        </IonTitle>
                    </IonToolbar>
                </IonHeader>
                <IonContent className="menuContent">
                    <IonList lines="none" className="menuList">
                        {pages.map((page) => (
                            page.subItems ? (
                                <React.Fragment key={page.label}>
                                    <IonItem mode='md' className="menuItem" onClick={() => setIsAusbildungOpen(!isAusbildungOpen)}>
                                        <IonIcon icon={page.icon} slot="start" color='primary' />
                                        <IonLabel>{page.label}</IonLabel>
                                        <IonIcon icon={isAusbildungOpen ? chevronDown : chevronForward} slot="end" />
                                    </IonItem>
                                    {isAusbildungOpen && page.subItems.map((subItem) => (
                                        <IonItem 
                                            href={`${match.url}/${subItem.link}`} 
                                            mode='md' 
                                            className="menuItem submenuItem" 
                                            key={subItem.link}
                                            color={path.startsWith(`${match.url}/${subItem.link}`) && "secondary"}
                                        >
                                            <IonLabel style={{ marginLeft: '2.5rem' }}>{subItem.label}</IonLabel>
                                        </IonItem>
                                    ))}
                                </React.Fragment>
                            ) : (
                                <IonItem 
                                    href={`${match.url}/${page.link}`} 
                                    mode='md' 
                                    className="menuItem" 
                                    key={page.link}
                                    color={path.startsWith(`${match.url}/${page.link}`) && "secondary"}
                                >
                                    <IonIcon icon={page.icon} slot="start" color='primary' />
                                    <IonLabel>{page.label}</IonLabel>
                                </IonItem>
                            )
                        ))}
                        {temporaryLoggedIn !== 1 ?
                            <IonItem href={`${match.url}/profil`} mode='md' className="menuItem" color={path.startsWith(`${match.url}/profil`) && "secondary"}>
                                <IonIcon icon={person} slot="start" color='primary' />
                                <IonLabel>Profil</IonLabel>
                            </IonItem> :
                            <IonItem href={`${match.url}/profil`} mode='md' className="menuItem" disabled color={path.startsWith(`${match.url}/profil`) && "secondary"}>
                                <IonIcon icon={person} slot="start" color='primary' />
                                <IonLabel>Profil</IonLabel>
                            </IonItem>
                        }
                    </IonList>
                    <div className="version-info">
                        v{packageJson.version}
                    </div>
                    
                </IonContent>
            </IonMenu>
            <IonRouterOutlet id="main">
                {pages.map((page) => {
                    if (page.subItems) {
                        return page.subItems.map(subItem => (
                            <Route 
                                exact 
                                path={`${match.url}/${subItem.link}`} 
                                key={subItem.link} 
                                component={subItem.component} 
                            />
                        ));
                    }
                    if (page.link === "newsfeed") {
                        return (
                            <Route path={`${match.url}/${page.link}/:hashtagId?/:hashtagLabel?`} key={page.link} component={page.component} />
                        )
                    }
                    return (
                        <Route exact path={`${match.url}/${page.link}`} key={page.link} component={page.component} />
                    )
                })}
                <Route exact path={`${match.url}/profil`}
                    render={() => {
                        return temporaryLoggedIn === 1 ? <ForbiddenPage /> : <Profile />
                    }}
                />

                <Route path={`${match.url}/statistik-templates/:id`} render={() => {
                    return user.member ? <ForbiddenPage /> : <StatisticsDetail editMode={false} />
                }} />

                <Route path={`${match.url}/statistik-bearbeiten/:id`} render={() => {
                    return user.member ? <ForbiddenPage /> : <StatisticsDetail editMode={true} />
                }} />

                <Route path={`${match.url}/statistik/:id`}>
                    <StatisticsDetailCompressed />
                </Route>

                <Route path={`${match.url}/newsfeed-artikel/:id`}>
                    <NewsfeedDetail />
                </Route>

                <Route path={`${match.url}/statistik-kategorien`}>
                    <StatisticCategories />
                </Route>

                <Route path={`${match.url}/medien-archiv/:id`}>
                    <MediaArchiveDetail />
                </Route>

                <Route path={`${match.url}/aktivitaet/:id`} render={(props) => <ActivityPage {...props} />}>
                </Route>

                {/* <Route path={`${match.url}/umfrage/:surveyId/:receiverId`} render={(props) => { return <SurveyPage {...props} /> }} /> */}


                <Route path={`${match.url}/excellent-company-registration/:intervalId`}>
                    <RegisterExcellentCompanyPage />
                </Route>


                <Route component={NotFoundPage} />

            </IonRouterOutlet>
        </IonSplitPane >
    )
}

export default withRouter(AppMenu);
